import React, { useEffect, useState } from 'react';
import { connect as unistoreConnect } from '@app/store/unistore/combined/react';
import userActions from '@app/actions/user';
import Login from '@app/login/Login';
import { LoadingDots } from '@app/ui';
import sportsApi from '@app/utils/sportsApi';
import { useIsMount } from '@app/components/hooks/useIsMount';

type SSOForwardPageProps = {
    user: any;
    sendNotification: any;
};

const SSOForwardPage = ({ user, sendNotification }: SSOForwardPageProps) => {
    const { isLoggedIn } = user;
    const [redirecting, setRedirecting] = useState(false);
    const isMounted = useIsMount();

    useEffect(() => {
        const body = document.querySelector('body');
        body.classList.add('body-gradient-theme');
        return () => {
            body.classList.remove('body-gradient-theme');
        };
    }, [isLoggedIn]);

    useEffect(() => {
        const fetchCredentialsAndRedirect = async () => {
            setRedirecting(true);
            try {
                // Fetch credentials from sports API
                const credentials = await sportsApi
                    .url('/zendesk/sso')
                    .get()
                    .res();
                const res = await credentials.text();

                const url = new URL(res);
                const domain = `${url.origin}${url.pathname}`;
                const jwtToken = url.searchParams.get('jwt');

                // Directly make a call to the Zendesk domain with JWT token
                window.location.href = `${domain}?jwt=${jwtToken}`;
            } catch (error) {
                sendNotification(
                    'Failed to fetch credentials from sports API',
                    {
                        context: 'error',
                    },
                );
                setRedirecting(false);
            }
        };

        if (!isMounted) return;
        if (isLoggedIn && !redirecting) {
            fetchCredentialsAndRedirect();
        }
    }, [isLoggedIn, isMounted, redirecting]);

    if (!isLoggedIn) {
        return (
            <Login descriptionText="Please log in to get redirected to Zendesk" />
        );
    }

    return (
        <main>
            <h1 className="gds-text--header-lg -color-tx-white">
                Redirecting to Zendesk
            </h1>
            <p className="-color-tx-white">Please wait a moment.</p>
            <section>
                <LoadingDots className="-m-t-5" context="white" />
            </section>
        </main>
    );
};

export default unistoreConnect(['user'], userActions)(SSOForwardPage);
